import AnimatedLogo from './AnimatedLogo';

customElements.define('animated-logo', AnimatedLogo);
